import React, { useEffect, useState } from 'react';
import classes from "./style.module.scss";
import InputBox from '../../component/InputBox';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import Button from '../../component/Button';
import { useNavigate } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import request from '../../service';
import Exported from '../../service/endpoints';
import { forgotPassword } from '../../redux/reducers/authSlice';
import { Toast } from '../../service/toast';
import { saveLoadingState } from '../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formMethods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
  } = formMethods;

  const backToLogin = () => {
    navigate('/auth/login');
  };

  const resendLink = () => {
    Toast({
      type: 'success',
      message: 'Link sent to registered email, please check'
    })
  };

  const handleMail = (data) => {
    const requestData = {
      email: data?.email,
    };
    dispatch(saveLoadingState(true))
    forgotPassword(requestData)
      .then((res) => {
        resendLink();
        dispatch(saveLoadingState(false))
      })
      .catch((err) => {
        Toast({
          type: 'error',
          message: 'Failed to send reset link. Please try again.'
        });
        dispatch(saveLoadingState(false))
      });
      setTimeout(() => {
        dispatch(saveLoadingState(false))
      }, 5000)
    
  };

  return (
    <div className='flex items-center justify-center'>
      <div className={`${classes.forgotPassword}`}>
        <p className={`${classes.forgotHeader} mb-5`}>FORGOT PASSWORD</p>
        <p className={`${classes.forgotText} mb-8`}>Please enter your registered email address. We will send you a link to reset your password.</p>
        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(handleMail)}>
            <div className='!mb-12'>
              <InputBox
                label={"Email"}
                icon={<MailOutlinedIcon sx={{ color: "#000000" }} />}
                className="w-[100%]"
                name={"email"}
                authInput
                {...register("email", {
                  required : true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
                error={errors.email}
                messages={{
                  required: "Email is required",
                  pattern: "Invalid email address",
                }}
              />
            </div>
            <Button text={"Send Reset Link"} className={`w-[100%] mb-[80px]`} />
          </form>
        </FormProvider>
        <div className='text-center'>
          <label className={`${classes.backToLogin}`} onClick={backToLogin}>Back to Login</label>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
